// Not in lib.dom yet. Chromium exposes it under the older `featurePolicy` name; the spec name is
// `permissionsPolicy`. Absent (Firefox, Safari) means "can't tell", which is treated as allowed.
interface PermissionsPolicyLike {
    allowsFeature(feature: string): boolean;
}

/**
 * False only when the browser can tell that this document's Permissions-Policy (its own header, or
 * the embedding page's iframe `allow`) blocks `feature`. A blocked feature rejects like a refused
 * prompt, but no browser setting can unblock it.
 */
export const isAllowedByPermissionsPolicy = (feature: string): boolean => {
    const doc = document as Document & {
        permissionsPolicy?: PermissionsPolicyLike;
        featurePolicy?: PermissionsPolicyLike;
    };
    const policy = doc.permissionsPolicy ?? doc.featurePolicy;
    return policy ? policy.allowsFeature(feature) : true;
};
